const checkInitAssetUrl = async (
    initAssetUrl: string,
    setSource: React.Dispatch<React.SetStateAction<string>>,
    setContentType: React.Dispatch<React.SetStateAction<string>>,
) => {
    if (/\.(webp|avif|gif|png|jpe?g)$/i.test(initAssetUrl)) {
        setSource(initAssetUrl)
        setContentType('image')
    } else {
        const xhr = new XMLHttpRequest()
        xhr.open('HEAD', initAssetUrl, true)

        xhr.addEventListener('load', function () {
            const contentType = xhr.getResponseHeader('Content-Type') as string
            setSource(initAssetUrl)
            setContentType(contentType)
        })

        xhr.send()
    }
}

export default checkInitAssetUrl
